import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/AssessmentModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/DiscSignalsTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/EditProfileModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/EndorsementArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/KnowYourTypeModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/PersonalityChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/PrintModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/RelationshipDatum.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/SectionCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/TaggingModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/assessments/BigFive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/assessments/Enneagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/assessments/Mbti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/assessments/Strengths.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/assessments/Values.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/BuildProfileEmptyState.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/CustomContent.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/DatumSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/DownloadGraphics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/MyPersonality.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/Overview.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/Playbooks.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/ProfileCompleteness.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/QuickMeetingTips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/TeamRoles.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/Traits.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/sections/WhatIsCrystal.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/Page.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/app/p/[slug]/components/MyPersonalityError.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/dashboard/backend/SWRProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/public/static/share/images/library-comparison.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/public/static/share/images/playbook_working_with.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/dashboard/public/static/share/images/playbook-onboarding-4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.26_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@1_jidgjqpwj735andnr6q7ycqrgi/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.26_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@1_jidgjqpwj735andnr6q7ycqrgi/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/react-error-boundary@4.1.2_react@18.3.1/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/crystal-eyes/components/add-ons/PhotoPersistHelper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/crystal-eyes/components/elements/Avatar/AvatarCircle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/crystal-eyes/components/elements/Avatar/IdentityCircle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/crystal-eyes/components/elements/Icon/Icon.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/crystal-eyes/components/elements/Loader/LoadingBar.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/crystal-eyes/components/views/profiles/DiscDescriptorPill.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/crystal-eyes/components/views/profiles/ProfileBadge.module.scss");
